import { LOCALE } from 'src/providers/types';
import { Translation, TranslationsWithId } from 'src/types';
import { PERIOD_TYPE } from 'src/features/stay/types';

export enum MEMBERSHIP_TEMPLATE_CATEGORY {
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    SUBSCRIPTION = 'subscription',
    RESERVATION = 'reservation',
    CUSTOM = 'custom',
}

type MembershipTranslation = {
    id: string;
    created_at: string;
    modified_at: string;
    language: LOCALE;
    name: string;
    description?: string;
};

export enum DAY_OF_WEEK {
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
    SUNDAY = 'sunday',
}

export enum DURATION_UNIT {
    HOUR = 'hour',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
}

export type AllowedTimes = {
    id: string;
    created_at: string;
    modified_at: string;
    day_of_week: DAY_OF_WEEK;
    from_time: string;
    to_time: string;
};

type MembershipRole = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    permissions: string[];
};

export type RestrictedGateway = {
    id: string;
    translations: Translation[];
    entry_zone: TranslationsWithId;
    exit_zone: TranslationsWithId;
};

export type MembershipType = {
    id: string;
    created_at: string;
    modified_at: string;
    membership_type_allowed_times: AllowedTimes[];
    translations: MembershipTranslation[];
    pricing_plan: {
        id: string;
        translations?: MembershipTranslation[];
    };
    category: MEMBERSHIP_TEMPLATE_CATEGORY;
    has_pricing_plan?: boolean;
    pricing_plan_identity?: string;
    apply_pricing_per_space?: boolean;
    allow_custom_space_count_definition?: boolean;
    limit_duration?: boolean;
    duration_unit: DURATION_UNIT;
    duration?: number;
    has_time_restriction?: boolean;
    has_access_restrictions?: boolean;
    has_allowed_spaces_count?: boolean;
    max_allowed_spaces_count?: number;
    allow_access_over_capacity_limit?: boolean;
    contribute_to_available_spaces?: boolean;
    allow_extra_visitors?: boolean;
    max_extra_visitors_count?: number;
    is_active?: boolean;
    auto_renew?: boolean;
    allow_access_as_client_outside_restrictions?: boolean;
    site: {
        id: string;
        translations: {
            language: LOCALE;
            name: string;
        }[];
    };
    restricted_gateways: RestrictedGateway[];
    limit_to_roles: MembershipRole[];
};

export type ZoneRule = {
    id: string;
    created_at: string;
    modified_at: string;
    allowed_stay_type?: PERIOD_TYPE;
    transit_time_minutes?: number;
    allowed_spaces_count?: number;
    reserve_spaces_count?: number;
    extra_visitors_count?: number;
    allowed_extra_visitors_time_minutes?: number;
    zone: TranslationsWithId;
};